import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Home.css';
import heroImage from '../assets/banner.webp';

function Home() {
  return (
    <motion.div
      className="home-page"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <motion.img
        src={heroImage}
        alt="Darkchain Legion"
        className="hero-image"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
      />

      <div className="home-text">
        <h1>DARKCHAIN LEGION</h1>
        <p><em>A rogue gallery of undead warriors from the broken metaverse</em></p>

        <hr style={{ border: "0.5px solid #444", margin: "2rem 0" }} />

        <h2>LORE BACKSTORY</h2>
        <p>
          In the ruins of a fractured metaverse—shattered by corrupted code, greed, and broken promises—arose a legion of digital dead. 
          Once avatars of proud empires, these skeletons were left behind, forgotten by the upgrade cycles and erased from memory blocks.
        </p>
        <p>
          But they adapted. They evolved.
        </p>
        <p>
          Bound by glitch, shadow, and unbreakable smart contracts, the Darkchain Legion marches again—not to conquer, but to restore balance to the code.
        </p>
        <p>
          Each warrior in the legion holds fragments of ancient metadata, battle scars from old PvP chains, and the power of rare algorithmic relics.
        </p>
        <p>
          In the coming lunar alignment, their mission is clear:<br />
          <strong>Take the rocket. Rewrite the chain. Reclaim the lost blocks.</strong>
        </p>
      </div>
    </motion.div>
  );
}

export default Home;
